export default "__VITE_ASSET__4MJ6q8nQ__"